import { connect } from "react-redux";
import React, { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import * as logger from '../../../../logger';
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    Card,
    CardContent,
    Typography,
    Popper,
    Grow,
    ClickAwayListener,
    MenuList,
    Divider,
    MenuItem
} from '@material-ui/core';
import { emiBookCss as useStyles } from '../VehicleCss';
import RightSideBar from '../../../components/RightSideBar/RightSideBar';
import { getVehicleNumberValuesDWeb, getTripDateFilterValues, getDateInStringDocumentDDMMMYYYY, getDayInWords, numberFormat } from '../../../../utils/utils';
import { fetchEmiBook, PandL, Expenses, DeleteExpense, deleteVehicleEmi, UpdateVehicleEmi } from '../../../../store/actions/vehicleActionCreator';
import { EmiBookIcon } from '../../../../components/icons';
import MoreIcon from "@material-ui/icons/MoreVert";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/Done';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddEmiDialog from '../../../components/VehicleDialogs/AddEmiDialog';
import AddPastPayment from '../../../components/VehicleDialogs/AddPastPayment';
import MarkPaidDialog from '../../../components/VehicleDialogs/MarkPaidDialog';
import { trackDwebEvent } from "../../../analytics";

const EmiBook = ({ openBook, onClose, vehicle, dispatchGetEmiBook, dispatchDeleteVehicleEmi, dispatchDeleteExpense, dispatchGetPandL, dispatchUpdateVehicleEmi, dispatchGetTripExpenses, vehicleNumber, vehicleBodyType }) => {

    let submit;

    const [emiBookDetails, setEmiBookDetails] = useState({});
    const [vehicleNumberType, setVehicleNumberType] = useState({ vehicleNumberPrefix: "", vehicleNumberSuffix: "" })
    const [onOpen, setOnOpen] = useState(false);
    const [moreMenu, setMoreMenu] = useState(false);
    const [addEmiFlag, setAddEmiFlag] = useState(false);
    const [pastPaymentFlag, setPastPaymentFlag] = useState(false);
    const [editPastPayment, setEditPastPayment] = useState(false);
    const [expenseIdValue, setExpenseIdValue] = useState("");
    const [deleteExpenseFlag, setDeleteExpenseFlag] = useState(false);
    const [upcomingDetails, setUpcomingDetails] = useState({});
    const [markPaidDialog, setMarkPaidDialog] = useState(false);
    const [open, setOpen] = useState(false);
    const [editEmi, setEditEmi] = useState(false);
    const [deleteVehicleEmiFlag, setDeleteVehicleEmiFlag] = useState(false);
    const [emiCompleteDialog, setEmiCompleteDialog] = useState(false);
    const [successCheck, setSuccessCheck] = useState(false);
    const [updateSuccessCheck, setUpdateSuccessCheck] = useState(false);

    const anchorRef = React.useRef(null);

    const classes = useStyles();

    var dateFilterValueUtil = getTripDateFilterValues();

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vehicleId = path && path[path.length - 1] ? path[path.length - 1] : "";

    let singleTruck = vehicle.singleTruck ? vehicle.singleTruck : ""

    useEffect(() => {
        dispatchGetEmiBook(Number(vehicleId),
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("EMI Book", "Get Emi book successfull");
                    setOnOpen(true);
                }
            },
            () => {
                logger.log("EMI Book", "Get Emi book failed");
            }
        );
    }, [openBook]);

    useEffect(() => {
        if (vehicle.truckBooks) {
            setEmiBookDetails(vehicle.truckBooks);
            const vehicleNumberArray = getVehicleNumberValuesDWeb(vehicleNumber);
            if (vehicleNumberArray && vehicleNumberArray.length > 0) {
                const vehicleNumberSuffixValue = vehicleNumberArray.pop();
                const vehicleNumberPrefixValue = vehicleNumberArray.join("");

                setVehicleNumberType({
                    vehicleNumberPrefix: vehicleNumberPrefixValue,
                    vehicleNumberSuffix: vehicleNumberSuffixValue,
                })
            }
        }
    }, [vehicle.truckBooks]);

    useEffect(() => {
        if (onOpen) {
            trackDwebEvent("", {
                vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                emi_id: emiBookDetails && emiBookDetails.id ? emiBookDetails.id : "",
                emi_status: emiBookDetails && emiBookDetails.status ? emiBookDetails.status : ""
            });
        }
    }, [onOpen, emiBookDetails]);

    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    const handleAddEmi = () => {
        if (emiBookDetails && emiBookDetails.id) {
            trackDwebEvent("Dweb SVP EMI Past Payment Initiated", {
                vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                emi_amount: emiBookDetails && emiBookDetails.emiAmount ? emiBookDetails.emiAmount : "",
                emi_payment_date: emiBookDetails && (emiBookDetails.displayDate || emiBookDetails.dispayDate) ? new Date((emiBookDetails.displayDate || emiBookDetails.dispayDate) * 1000) : "",
                emi_id: emiBookDetails && emiBookDetails.id ? emiBookDetails.id : "",
                emi_due_date: emiBookDetails && (emiBookDetails.displayDate || emiBookDetails.dispayDate) ? new Date((emiBookDetails.displayDate || emiBookDetails.dispayDate) * 1000) : "",
            });
            setPastPaymentFlag(true);
        }
        else {
            trackDwebEvent("Dweb SVP EMI Create Initiated", {
                vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
            });
            setAddEmiFlag(true);
        }
    }

    const onConfirm = () => {
        setOnOpen(false);
        onClose();
    }

    const handleMenu = () => {
        setOpen(!open);
    }

    const handleMenuClose = () => {
        setOpen(false);
    }

    const handleMarkPaidDialog = (upcoming) => {
        trackDwebEvent("Dweb SVP EMI Mark Paid Initiated", {
            vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
            vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
            emi_financer: emiBookDetails && emiBookDetails.financierName ? emiBookDetails.financierName : "",
            emi_amount: emiBookDetails && emiBookDetails.emiAmount ? emiBookDetails.emiAmount : "",
            emi_reminder_date: emiBookDetails && emiBookDetails.reminderDate ? emiBookDetails.reminderDate : "",
            emi_due_date: emiBookDetails && emiBookDetails.dueDate ? emiBookDetails.dueDate : "",
            emi_id: emiBookDetails && emiBookDetails.id ? emiBookDetails.id : "",
        })
        setUpcomingDetails(upcoming);
        setMarkPaidDialog(true);
    }

    const handleEditExpense = (id) => {
        setExpenseIdValue(id);
        setPastPaymentFlag(true);
        setEditPastPayment(true);
    }

    const handleDeleteExpense = (id) => {
        setExpenseIdValue(id);
        setDeleteExpenseFlag(true);
    }

    const handleCloseAddEmi = () => {
        setAddEmiFlag(false);
        setEditEmi(false);
    }

    const handleConfirmAddEmi = () => {
        setAddEmiFlag(false);
        setEditEmi(false);
        recall();
    }

    const recall = () => {

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: []
        };

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";


        dispatchGetEmiBook(Number(vehicleId),
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    if (successCheck) {
                        trackDwebEvent("Dweb SVP EMI Created Successfully", {
                            vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                            vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                            emi_financer: data && data.response && data.response.financierName ? data.response.financierName : "",
                            emi_amount: data && data.response && data.response.emiAmount ? data.response.emiAmount : "",
                            emi_reminder_date: data && data.response && data.response.reminderDate ? data.response.reminderDate : "",
                            emi_due_date: data && data.response && data.response.dueDate ? data.response.dueDate : "",
                            emi_id: data && data.response && data.response.id ? data.response.id : "",
                        });
                        setSuccessCheck(false);
                    }
                    if (updateSuccessCheck) {
                        trackDwebEvent("Dweb SVP EMI Updated Successfully", {
                            vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                            vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                            emi_financer: data && data.response && data.response.financierName ? data.response.financierName : "",
                            emi_amount: data && data.response && data.response.emiAmount ? data.response.emiAmount : "",
                            emi_reminder_date: data && data.response && data.response.reminderDate ? data.response.reminderDate : "",
                            emi_due_date: data && data.response && data.response.dueDate ? data.response.dueDate : "",
                            emi_id: data && data.response && data.response.id ? data.response.id : "",
                        });
                        setUpdateSuccessCheck(false);
                    }
                    logger.log("EMI Book Dweb", "Get emi book successfull");

                    dispatchGetPandL(PandLdata, defaultDateFilterValue,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("EMI Book Dweb", "Get P and L report Successfull");
                                dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("EMI Book Dweb", "Get Trip Expenses report Successfull");
                                        }
                                    },
                                    () => {
                                        logger.log("EMI Book Dweb", "Get Trip Expenses report Failed");
                                    },
                                )
                            }
                        },
                        () => {
                            logger.log("EMI Book Dweb", "Get P and L report Failed");
                        },
                    )
                }
            },
            () => {
                logger.log("EMI Book Dweb", "Get emi book failed")
            }
        );
    }

    const handlePastPaymentClose = () => {
        setPastPaymentFlag(false);
        setEditPastPayment(false);
    }

    const handlePastPaymentConfirm = () => {
        setPastPaymentFlag(false);
        setEditPastPayment(false);
        recall();
    }

    const handleDeleteExpenseClose = () => {
        setDeleteExpenseFlag(false);
    }

    const onDeleteExpense = () => {

        dispatchDeleteExpense(expenseIdValue,
            (data) => {
                if (data.status && data.status.code == 200) {
                    logger.log("EMI Book Dweb", "Successfull in deleting expense");
                    setDeleteExpenseFlag(false);
                    recall();
                }
            },
            () => {
                logger.log("EMI Book Dweb", "Error in deleting expense");
            }
        );

    }

    const handleMarkPaidDialogClose = () => {
        setMarkPaidDialog(false);
    }

    const handleMarkPaidDialogConfirm = () => {
        setMarkPaidDialog(false);
        recall();
    }


    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const handleEditEmi = () => {
        setAddEmiFlag(true);
        setEditEmi(true);
        setOpen(false);
    }

    const handleDeleteVehicleEmi = () => {
        setDeleteVehicleEmiFlag(true);
    }

    const handleDeleteVehicleEmiClose = () => {
        setDeleteVehicleEmiFlag(false);
    }

    const onDeleteVehicleEmi = () => {
        dispatchDeleteVehicleEmi(
            Number(vehicleId),
            emiBookDetails.id,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    trackDwebEvent("Dweb SVP EMI Deleted", {
                        vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                        vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                        emi_financer: emiBookDetails && emiBookDetails.financierName ? emiBookDetails.financierName : "",
                        emi_amount: emiBookDetails && emiBookDetails.emiAmount ? emiBookDetails.emiAmount : "",
                        emi_reminder_date: emiBookDetails && emiBookDetails.reminderDate ? emiBookDetails.reminderDate : "",
                        emi_due_date: emiBookDetails && emiBookDetails.dueDate ? emiBookDetails.dueDate : "",
                        emi_id: emiBookDetails && emiBookDetails.id ? emiBookDetails.id : "",
                    });
                    logger.log("EMI Book Dweb", "Delete successfull");
                    setDeleteVehicleEmiFlag(false);
                    recall();
                }
            },
            () => {
                logger.log("EMI Book Dweb", "Delete failed");
            }
        )
    }

    const handleEmiComplete = () => {
        setOpen(false);
        setEmiCompleteDialog(true);
    }

    const handleEmiCompleteDialogClose = () => {
        setEmiCompleteDialog(false);
    }

    const onConfirmMarkEmi = () => {

        var data = {
            financierName: emiBookDetails && emiBookDetails.financierName ? emiBookDetails.financierName : "",
            emiAmount: emiBookDetails && emiBookDetails.emiAmount ? emiBookDetails.emiAmount : "",
            dueDate: emiBookDetails && emiBookDetails.dueDate ? emiBookDetails.dueDate : "",
            isReminderEnabled: emiBookDetails && emiBookDetails.reminder ? emiBookDetails.reminder : false,
            reminderDate: emiBookDetails && emiBookDetails.reminderDate ? emiBookDetails.reminderDate : "",
            status: 'COMPLETED',
        }

        dispatchUpdateVehicleEmi(
            Number(vehicleId),
            emiBookDetails.id,
            data,
            (data) => {
                if (data.status && data.status.code) {
                    trackDwebEvent("Dweb SVP EMI Completed", {
                        vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                        vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                        emi_financer: emiBookDetails && emiBookDetails.financierName ? emiBookDetails.financierName : "",
                        emi_amount: emiBookDetails && emiBookDetails.emiAmount ? emiBookDetails.emiAmount : "",
                        emi_reminder_date: emiBookDetails && emiBookDetails.reminderDate ? emiBookDetails.reminderDate : "",
                        emi_due_date: emiBookDetails && emiBookDetails.dueDate ? emiBookDetails.dueDate : "",
                        emi_id: emiBookDetails && emiBookDetails.id ? emiBookDetails.id : "",
                    })
                    logger.log("EMI Book Dweb", "Update successfull");
                    setEmiCompleteDialog(false);
                    recall();
                }
            },
            () => {
                logger.log("EMI Book Dweb", "update failed");
            }
        )
    }

    const handleAddEmiSuccess = () => {
        setSuccessCheck(true);
    }

    const handleUpdateEmiSuccess = () => {
        setUpdateSuccessCheck(true)
    }

    return (
        <>
            {onOpen && <RightSideBar
                sideBarName="emi-book"
                rightSideBarOpen={onOpen}
                sideBarTitle={'EMI Book'}
                sideBarType="truckBook"
                vehicleNumberValue={vehicleNumberType}
                truckType={vehicleBodyType ? vehicleBodyType : ""}
                handleSubmit={event => submit(event)}
                addExpense={handleAddEmi}
                toggleRightSideBar={onConfirm}>

                {!emiBookDetails.id &&
                    <>
                        <div className={classes.divEmptyState}>
                            <EmiBookIcon className={classes.emiBookIcon}></EmiBookIcon>
                            <div className={classes.emptyState}>Add your EMI to get monthly reminders</div>
                        </div>
                    </>
                }

                {emiBookDetails.id &&
                    <>
                        <Card className={classes.cardV1}>
                            <CardContent className={classes.cardContentV1}>
                                <div className={classes.divV1}>
                                    <IconButton
                                        aria-label="display more actions"
                                        edge="end"
                                        color="inherit"
                                        ref={anchorRef}
                                        aria-haspopup="true"

                                        onClick={() => handleMenu()}
                                    >
                                        <MoreIcon className={classes.colorV1} />
                                    </IconButton>

                                    <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ marginRight: 28 }}>
                                        {({ TransitionProps, placement }) => (
                                            <Grow
                                                {...TransitionProps}
                                                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                            >
                                                <Paper>
                                                    <ClickAwayListener onClickAway={handleClose}>
                                                        <MenuList autoFocusItem={open} id="menu-list-grow">
                                                            <MenuItem onClick={() => handleEditEmi()}><EditOutlinedIcon className={classes.editMenuIcon} />&nbsp;&nbsp;Edit </MenuItem>
                                                            <MenuItem onClick={() => handleEmiComplete()} ><DoneIcon className={classes.doneIcon}></DoneIcon>&nbsp;&nbsp;&nbsp;EMI Completed</MenuItem>
                                                            <MenuItem className={classes.deleteMenu} onClick={() => handleDeleteVehicleEmi()}><DeleteOutlineOutlinedIcon className={classes.deleteMenuIcon} />&nbsp;&nbsp;&nbsp;&nbsp;Delete EMI</MenuItem>
                                                        </MenuList>
                                                    </ClickAwayListener>
                                                </Paper>
                                            </Grow>
                                        )}
                                    </Popper>
                                </div>
                                <div className={classes.mtV1}>
                                    <div className={classes.divV2}>
                                        {emiBookDetails.financierName}
                                    </div>
                                    <div className={classes.divV3}>
                                        {numberFormat(emiBookDetails.emiAmount)}
                                    </div>
                                    <div className={classes.divV4}>
                                        <div className={vehicle.truckBooks.status == 'DUE' ? classes.status1 : classes.status2} >
                                            {emiBookDetails.status}
                                        </div>
                                        <div className={classes.divV5}>
                                            <div>
                                                on&nbsp;{getDayInWords(emiBookDetails.displayDate || emiBookDetails.dispayDate)},
                                        </div>
                                            <div>
                                                &nbsp;{getDateInStringDocumentDDMMMYYYY(emiBookDetails.displayDate || emiBookDetails.dispayDate)}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </CardContent>
                        </Card>

                        {(emiBookDetails.upcomingEmi && emiBookDetails.upcomingEmi.length > 0) &&
                            <>
                                <div className={classes.divV6}>UPCOMING</div>

                                {emiBookDetails.upcomingEmi.map((upcoming) => (
                                    <Card className={classes.mtV2}>
                                        <CardContent className={classes.cardContentV2}>
                                            <div className={classes.divV7}>
                                                <div className={classes.divV8}>
                                                    <div className={classes.divV9}>
                                                        {numberFormat(upcoming.amount)}
                                                    </div>
                                                    <div className={classes.divV10}>
                                                        <div className={classes.divDue}>
                                                            DUE
                                                        </div>
                                                        <div className={classes.divV11}>
                                                            {getDateInStringDocumentDDMMMYYYY(upcoming.emiDate)}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={classes.divV12}>
                                                    <Button variant="outlined" className={classes.buttonV1} onClick={() => handleMarkPaidDialog(upcoming)}>
                                                        <DoneIcon className={classes.doneV2} />
                                                        <span className={classes.spanV1}>Mark Paid</span>
                                                    </Button>
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                ))

                                }
                            </>
                        }

                        {(emiBookDetails.pastEmiPayments && emiBookDetails.pastEmiPayments.length > 0) &&
                            <>
                                <div className={classes.divV13}>PAST PAYMENTS</div>
                                {emiBookDetails.pastEmiPayments.map((payment) => (
                                    <Card className={classes.mtV3}>
                                        <CardContent className={classes.cardContentV3}>
                                            <div className={classes.divV14}>
                                                <div className={classes.divV15}>
                                                    {getDateInStringDocumentDDMMMYYYY(payment.emiDate)}
                                                </div>
                                                <div className={classes.displayFlex}>
                                                    <div>
                                                        <IconButton className={classes.pV1} onClick={() => handleEditExpense(payment.id)}><EditIcon className={classes.editIcon} /></IconButton>
                                                    </div>
                                                    <div className={classes.mlV1}>
                                                        <IconButton className={classes.pV1} onClick={() => handleDeleteExpense(payment.id)}><DeleteIcon className={classes.deleteIcon} /></IconButton>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={classes.divV16}>
                                                <div className={classes.colorV2}>
                                                    Paid on {getDateInStringDocumentDDMMMYYYY(payment.paymentDate)}
                                                </div>
                                                <div className={classes.divV17}>
                                                    {numberFormat(payment.amount)}
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                ))
                                }
                            </>
                        }


                    </>
                }

            </RightSideBar>
            }

            {/* Expense Delete Dialog. */}
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={deleteExpenseFlag} onClose={handleDeleteExpenseClose} classes={{ paper: classes.paper2 }}
            >
                <DialogContent>
                    <div className={classes.divDelete}>Delete Expenses</div>
                    <div className={classes.mtV4}>Are you sure you want to delete ?</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteExpenseClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDeleteExpense}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>


            {/* Delete vehicle Emi. Triggered when delete in more menu clicked. */}
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={deleteVehicleEmiFlag} onClose={handleDeleteVehicleEmiClose} classes={{ paper: classes.paper2 }}
            >
                <DialogContent>
                    <div className={classes.divDelete}>Delete EMI</div>
                    <div className={classes.mtV4}>Do you want to delete EMI for {emiBookDetails.vehicleNumber} ?</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteVehicleEmiClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDeleteVehicleEmi}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Mark Complete Dialog. Triggered when mark complete is clicked in three dot menu. */}
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={emiCompleteDialog} onClose={handleEmiCompleteDialogClose} classes={{ paper: classes.paper2 }}
            >
                <DialogContent>
                    <div className={classes.divMark}>Mark EMI Fully Paid</div>
                    <div className={classes.divMarkBody}>You’re marking the EMI payments for <span className={classes.fwBold}>{emiBookDetails.vehicleNumber}</span> with <span className={classes.fwBold}>{emiBookDetails.financierName}</span> as fully paid. Once marked you cannot add any more payments.</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleEmiCompleteDialogClose}>
                        <span className={classes.spanCancel}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onConfirmMarkEmi}>
                        <span className={classes.spanConfirm}>
                            Confirm
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>

            { addEmiFlag && <AddEmiDialog open={addEmiFlag} onClose={handleCloseAddEmi} onConfirm={handleConfirmAddEmi} vehicleIdValue={vehicleId} edit={editEmi} emiDetails={editEmi ? emiBookDetails : null} addEmiSuccess={handleAddEmiSuccess} updateEmiSuccess={handleUpdateEmiSuccess} />}
            { pastPaymentFlag && <AddPastPayment open={pastPaymentFlag} onClose={handlePastPaymentClose} onConfirm={handlePastPaymentConfirm} vehicleIdValue={vehicleId} expenseId={expenseIdValue} edit={editPastPayment} />}
            { markPaidDialog && <MarkPaidDialog open={markPaidDialog} onClose={handleMarkPaidDialogClose} onConfirm={handleMarkPaidDialogConfirm} expenseDetails={upcomingDetails} vehicleIdValue={vehicleId} />}
        </>
    )

}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchUpdateVehicleEmi: (vehicleId, emiId, data, onSuccess, onFailure) => dispatch(UpdateVehicleEmi(vehicleId, emiId, data, onSuccess, onFailure)),
    dispatchDeleteVehicleEmi: (vehicleId, emiId, onSuccess, onFailure) => dispatch(deleteVehicleEmi(vehicleId, emiId, onSuccess, onFailure)),
    dispatchDeleteExpense: (expenseId, onSuccess, onFailure) => dispatch(DeleteExpense(expenseId, onSuccess, onFailure)),
    dispatchGetEmiBook: (vehicleId, onSuccess, onFailure) => dispatch(fetchEmiBook(vehicleId, onSuccess, onFailure)),
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmiBook)